import type { TmWrappers } from '@/wrappers'

export const addNewPinnedItemModalId = 'addNewPinnedContactsModal' satisfies TmWrappers

export const PINNED_CONTACTS_ITEMS_PER_PAGE = 25

export interface OnContactsAutocompleteResponseBody {
  entityType: 'contact' | 'list' | 'filtered_view'
  entityId: number
  title: string
  value: string
  avatarHref: string | null
}
